import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "../assets/css/Cards.css";

const cardData = [
  { id: "subscribers", label: "Subscribers", className: "subscribers", link: "/subscribers-list", apiKey: "subscribers_count" },
  { id: "brands", label: "Brands", className: "brands", link: "/brands-list", apiKey: "brands_count" },
  { id: "products", label: "Products", className: "products", link: "/products-list", apiKey: "products_count" },
  { id: "offers", label: "Offers", className: "offers", link: "/offer-list", apiKey: "offers_count" },
  { id: "banners", label: "Banners", className: "banners", link: "/banner-list", apiKey: "banners_count" },
  { id: "focus_areas", label: "Focus Areas", className: "focus-areas", link: "/focus-list", apiKey: "focus_areas_count" },
  { id: "testimonials", label: "Testimonials", className: "testimonials", link: "/testimonial-list", apiKey: "testimonials_count" },
  { id: "contacts", label: "Contacts", className: "contacts", link: "/contact-list", apiKey: "contacts_count" },
];

export default function Cards() {
  const baseURL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("profileToken");
  const [counts, setCounts] = useState({}); // ✅ api se result
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${baseURL}/dashboard/counts`, {
          headers: { "x-access-token": token || "" },
        });
        if (res.data?.status) setCounts(res.data.result || {});
      } catch (e) {
        console.error("Counts fetch error:", e);
      } finally {
        setLoading(false);
      }
    })();
  }, [baseURL, token]);

  return (
    <div className="cards-container" role="region" aria-label="Dashboard cards">
      {cardData.map((card) => (
        <section key={card.id} className={`card ${card.className}`}>
          <strong id={`${card.id}-count`}>
            {loading ? "..." : counts?.[card.apiKey] ?? 0}
          </strong>

          <span id={`${card.id}-label`}>{card.label}</span>

          <Link to={card.link} className="more-info" aria-label={`Open ${card.label} list`}>
            View List <i className="fa-solid fa-arrow-right"></i>
          </Link>
        </section>
      ))}
    </div>
  );
}
